import { Button, message, Popconfirm, Space, Table, Input } from 'antd';
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

const AdminNoticePage = () => {
    const [dataSource, setDataSource] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const screens = useBreakpoint();

    const deleteNotice = async (noticeId) => {
        try {
            const response = await fetch(`${apiUrl}/api/notice/${noticeId}`, {
                method: "DELETE",
            });

            if (response.ok) {
                fetchNotice();
                message.success("Duyuru başarıyla silindi");
            } else {
                message.error("Duyuru silme işlemi başarısız.");
            }
        } catch (error) {
            console.error("Silme Hatası", error);
        }
    };

    const fetchNotice = useCallback(async () => {
        try {
            const response = await fetch(`${apiUrl}/api/notice`);
            if (response.ok) {
                const data = await response.json();
    
                const sortedData = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    
                setDataSource(sortedData);
                setFilteredData(sortedData);
            } else {
                message.error("Duyurular getirilemedi.");
            }
        } catch (error) {
            console.error("Veri çekme hatası", error);
        }
    }, [apiUrl]);
    

    useEffect(() => {
        fetchNotice();
    }, [fetchNotice]);

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchText(value);

        const filtered = dataSource.filter(
            (item) =>
                item.title.toLowerCase().includes(value) ||
                item.content.toLowerCase().includes(value)
        );
        setFilteredData(filtered);
    };

    const truncateText = (text, length) => {
        return text.length > length ? `${text.slice(0, length)}...` : text;
    };

    const truncateContent = (htmlContent, wordLimit) => {
        // HTML etiketlerini temizleyerek düz metne çevirme
        const textOnly = htmlContent.replace(/<[^>]+>/g, " ");
        const words = textOnly.split(/\s+/).slice(0, wordLimit).join(" ");
        return words.length > 0 ? `${words}...` : "";
    };

    const columns = [
            {
                title: 'Başlık',
                dataIndex: 'title',
                key: 'title',
                render: (text) => <b>{truncateText(text, 20)}</b>, 
                responsive: ['xs', 'sm', 'md', 'lg'],
            },
            {
                title: 'İçerik',
                dataIndex: 'content',
                key: 'content',
                responsive: ['sm', 'md', 'lg'],
                render: (text) => (
                    <div dangerouslySetInnerHTML={{ __html: truncateContent(text, 10) }} />
                ), 
            },
            {
                title: 'Oluşturulma Tarihi',
                dataIndex: 'createdAt',
                key: 'createdAt',
                responsive: ['md', 'lg'],
            },
            {
                title: "İşlemler",
                key: "actions",
                render: (_, record) => (
                    <Space size="middle">
                        <Button onClick={() => navigate(`/admin/notice/update/${record.id}`)} type='primary'>
                            Düzenle
                        </Button>
                        <Popconfirm
                            title="Duyuruyu Sil"
                            description="Duyuruyu silmek istediğinizden emin misiniz?"
                            okText="Evet"
                            cancelText="Hayır"
                            onConfirm={() => deleteNotice(record.id)}
                        >
                            <Button type='primary' danger>Sil</Button>
                        </Popconfirm>
                    </Space>
                ),
                responsive: ['xs', 'sm', 'md', 'lg'],
            }
        
        ]
 

    return (
        <>
            <Input
                placeholder="Duyuru ara.."
                value={searchText}
                onChange={handleSearch}
                style={{ marginBottom: 16, width: screens.xs ? '100%' : 300 }}
            />

            <Table
                pagination={{ pageSize: 5 }}
                rowKey={(record) => record.id}
                dataSource={filteredData}
                columns={columns}
                scroll={{ x: 'max-content' }}
            />
        </>
    );
}

export default AdminNoticePage;
